var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUruguay(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 11.8264H31.4488C31.0476 10.3381 30.4379 8.9355 29.6516 7.6525H16V11.8264Z",
    fill: "#338AF3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.03996 28.5213H25.9595C27.4197 27.3583 28.672 25.9457 29.6513 24.3474H2.34814C3.32758 25.9457 4.57983 27.3583 6.03996 28.5213V28.5213Z",
    fill: "#338AF3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 0V3.47825H25.9598C23.2267 1.3015 19.7656 0 16 0V0Z",
    fill: "#338AF3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 11.8264H31.4488C31.0476 10.3381 30.4379 8.9355 29.6516 7.6525H16V11.8264Z",
    fill: "#338AF3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 17.4442 0.1925 18.8431 0.551188 20.1739H31.4489C31.8075 18.8431 32 17.4442 32 16H0Z",
    fill: "#338AF3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.913 9.36367L11.9589 10.2829L12.9994 12.1754L10.8776 11.7695L10.6087 13.9129L9.13082 12.3364L7.65282 13.9129L7.38401 11.7695L5.26213 12.1752L6.30263 10.2828L4.34863 9.36367L6.3027 8.44461L5.26213 6.55211L7.38394 6.95798L7.65288 4.81454L9.13082 6.39104L10.6088 4.81454L10.8776 6.95798L12.9995 6.55211L11.9589 8.44467L13.913 9.36367Z",
    fill: "#FFDA44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUruguay);
export default __webpack_public_path__ + "static/media/uruguay.0e69ee81.svg";
export { ForwardRef as ReactComponent };